import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const newCategoriesToAdd = [
  {
    name: 'Gardening',
    description: 'Professional gardening and landscaping services',
    icon: '🌱',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80'
  },
  {
    name: 'Carpentry',
    description: 'Expert carpentry and woodwork services',
    icon: '🔨',
    image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=800&q=80'
  },
  {
    name: 'Appliance Repair',
    description: 'Repair services for all home appliances',
    icon: '🔧',
    image: 'https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=800&q=80'
  },
  {
    name: 'Pest Control',
    description: 'Professional pest control and fumigation services',
    icon: '🐛',
    image: 'https://images.unsplash.com/photo-1563207153-f403bf289096?w=800&q=80'
  },
  {
    name: 'Painting',
    description: 'Interior and exterior painting services',
    icon: '🎨',
    image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&q=80'
  },
  {
    name: 'Moving & Packing',
    description: 'Relocation and packing services',
    icon: '📦',
    image: 'https://images.unsplash.com/photo-1600518464441-9154a4dea6b7?w=800&q=80'
  },
  {
    name: 'Interior Design',
    description: 'Professional interior design consultation',
    icon: '🏠',
    image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=800&q=80'
  }
];

export async function addNewCategories() {
  try {
    console.log('Checking existing categories...');
    const snapshot = await getDocs(collection(db, 'categories'));
    const existingNames = snapshot.docs.map(doc => doc.data().name);
    console.log('Existing categories:', existingNames);
    
    console.log('\nAdding new categories...');
    let added = 0;
    
    for (const category of newCategoriesToAdd) {
      if (!existingNames.includes(category.name)) {
        await addDoc(collection(db, 'categories'), {
          ...category,
          createdAt: new Date().toISOString(),
          isActive: true
        });
        console.log(`✅ Added: ${category.name}`);
        added++;
      } else {
        console.log(`⏭️  Skipped (already exists): ${category.name}`);
      }
    }
    
    console.log(`\n✨ Successfully added ${added} new categories!`);
    return { success: true, added };
  } catch (error) {
    console.error('Error adding categories:', error);
    return { success: false, error };
  }
}
